import vuetify from "@/plugins/vuetify";

type TranslateType = Function;
type TranslateReplaceValueType = Function;

const replaceValues: TranslateReplaceValueType = (string: string = "", replaces: any): String => {
  if (!!replaces) {
    Object?.entries(replaces)?.forEach((replace) => {
      if (replace) {
        string = string.replace(`{${replace?.[0]}}`, replace?.[1] as string);
      }
    });
  }

  return string;
};

export const Translate: TranslateType = (text: string = "", replace): String => {
  let string = vuetify.framework.lang.t(`$vuetify.${text}`);
  return replaceValues(string, replace);
};

export const AppTranslate = {
  install(Vue) {
    Vue.prototype.$t = Translate;
  },
};
